<template>
  <div>
    <bita-breadcrumb :items="breadCrumbs" />

    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row" style="flex-direction: row-reverse;">
        <!-- ستون اصلی اطلاعات راننده -->
        <div class="col-lg-10 col-md-8">
          <bita-ibox :is-loading="isLoading">
            <div slot="body">
              <div class="row">
                <bita-input type="text" name="national_code" label="کد ملی" rules="irani"
                  :validation-container-class="'col-2'" input-class="form-control" v-model="nationalCode" />

                <bita-input type="text" name="mobile" label="موبایل" :validation-container-class="'col-2'"
                  input-class="form-control" v-model="mobile" />

                <div class="col-3">
                  <button class="btn btn-primary col-4 mt-4" @click="searchMobile()">
                    <i class="fas fa-search" />
                    جستجو
                  </button>
                </div>

                <div class="row mb-3 align-items-center">
                  <div class="col-md-2 text-center">
                    <i class="fas fa-user-circle fa-5x text-muted" style="color: #dee2e6;"></i>
                  </div>
                  <div class="col-md-10">
                    <h3 class="font-weight-bold">
                      {{ driver && driver.user ? driver.user.name : "" }}
                      {{ driver && driver.user ? driver.user.family : "" }}
                    </h3>
                    <p class="mt-2 text-muted">
                      <strong>شماره موبایل:</strong>
                      <span class="text-dark">{{
                        driver && driver.user ? driver.user.phone : ""
                        }}</span>
                      &nbsp;|&nbsp;
                      <strong>کد ملی:</strong>
                      <span class="text-dark">{{
                        driver && driver.user ? driver.user.national_code : ""
                        }}</span>
                      &nbsp;|&nbsp;
                      <strong>وضعیت:</strong>
                      <span v-html="statusText(driver)"></span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </bita-ibox>

          <!-- تب‌بندی اطلاعات -->
          <div class="custom-tabs-container mt-1" v-if="driver && driver.id" :key="driver.id">
            <ul class="nav nav-tabs custom-nav-tabs" role="tablist">
              <li class="nav-item">
                <a class="nav-link active" data-toggle="tab" href="#tab-dashboard">داشبورد</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-info">اطلاعات کاربری</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-activity">گزارش فعالیت</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-tickets">نوبت‌ها</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-wallet">گزارش مالی</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-map" @click="invalidateMap">موقعیت نقشه</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-logs">وضعیت بارها</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-sms">پیامک‌ها</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-priorities">اولویت‌ها</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-drivers">رانندگان</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" data-toggle="tab" href="#tab-activity-history" @click="loadDriverActivityHistory">
                  تاریخچه فعالیت
                </a>
              </li>

            </ul>

            <div class="tab-content custom-tab-content">
              <div role="tabpanel" id="tab-dashboard" class="tab-pane active">
                <div class="panel-body">
                  <!-- خلاصه اطلاعات پایه -->
                  <div class="row mb-3">
                    <div class="col-md-3">
                      <div class="small-box bg-light p-2 border rounded">
                        <div class="text-muted">شماره هوشمند راننده</div>
                        <div class="font-weight-bold">
                          {{ driver.driver_smartnumber || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-light p-2 border rounded">
                        <div class="text-muted">شماره هوشمند ماشین</div>
                        <div class="font-weight-bold">
                          {{ driver.car_smartnumber || "-" }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-light p-2 border rounded">
                        <div class="text-muted">پلاک</div>
                        <div class="font-weight-bold">
                          {{
                            driver.display_plate ? driver.display_plate : "-"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="small-box bg-light p-2 border rounded">
                        <div class="text-muted">نوع ماشین</div>
                        <div class="font-weight-bold">
                          {{ getVehicleTypeName(driver.vehicle_type_id) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- خلاصه گزارش‌ها -->
                  <div class="row">
                    <!-- آخرین بارها (جدولی) -->
                    <div class="col-lg-6 mb-3">
                      <div class="card p-2 border rounded">
                        <h6 class="mb-2 text-primary">آخرین بارها</h6>

                        <div class="table-responsive" v-if="lastLoads.length">
                          <table class="table table-sm table-bordered table-striped text-center mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th>مبدا</th>
                                <th>مقصد</th>
                                <th>تاریخ بارگیری</th>
                                <th>وضعیت</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, i) in lastLoads" :key="i">
                                <td>{{ item.request.origin_name || "-" }}</td>
                                <td>
                                  {{ item.request.destination_name || "-" }}
                                </td>
                                <td>
                                  {{
                                    item.request.loading_at
                                      ? $getJalaliDate(item.request.loading_at)
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  <span>
                                    {{ item.state }}
                                  </span>
                                </td>
                                <td>
                                  <div class="d-flex justify-content-center flex-wrap" style="gap: 5px">
                                    <!-- تغییر وضعیت بار -->
                                    <button type="button" class="btn btn-success btn-sm"
                                      @click="edit(item.request_detail)">
                                      <i class="far fa-flag"></i>
                                      تغییر وضعیت
                                    </button>

                                    <!-- کنسل بار -->
                                    <button v-if="
                                      $acl.can('delete', 'requests') ||
                                      ($acl.roles && $acl.roles.includes('carrier_test'))
                                    " type="button" class="btn btn-danger btn-sm" @click="cancelLoad(item)">
                                      <i class="fas fa-times"></i>
                                      کنسل بار
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div v-else class="text-muted small">
                          موردی یافت نشد.
                        </div>
                      </div>
                    </div>

                    <!-- آخرین نوبت‌ها (جدولی) -->
                    <div class="col-lg-6 mb-3">
                      <div class="card p-2 border rounded">
                        <h6 class="mb-2 text-warning">آخرین نوبت‌ها</h6>

                        <div class="table-responsive" v-if="lastCanceledTickets.length">
                          <table class="table table-sm table-bordered table-striped text-center mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th>ترمینال</th>
                                <th>سالن</th>
                                <th>وضعیت</th>
                                <th>انقضاء</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, i) in lastCanceledTickets" :key="i">
                                <td>{{ item.terminal_name || "-" }}</td>
                                <td v-html="ticketSalonNameText(item)"></td>
                                <td v-html="item.status ? statusText(item) : '-'"></td>
                                <td>
                                  {{
                                    item.expire_at
                                      ? $getJalaliDateTime(item.expire_at)
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div v-else class="text-muted small">
                          نوبتی یافت نشد.
                        </div>
                      </div>
                    </div>

                    <!-- ۵ پیامک آخر (جدولی) -->
                    <div class="col-lg-6 mb-3">
                      <div class="card p-2 border rounded">
                        <h6 class="mb-2 text-info">۵ پیامک آخر</h6>

                        <div class="table-responsive" v-if="lastSms.length">
                          <table class="table table-sm table-bordered table-striped text-center mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th>نوع</th>
                                <th>فعالیت</th>
                                <th>سالن</th>
                                <th>مبدا</th>
                                <th>مقصد</th>
                                <th>تاریخ ایجاد</th>
                                <th>تاریخ ارسال</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(sms, i) in lastSms" :key="i">
                                <td>{{ sms.type || "-" }}</td>
                                <td>{{ sms.action || "-" }}</td>
                                <td>
                                  {{
                                    sms.request ? sms.request.salon.name : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    sms.request
                                      ? `${sms.request.origin.province.name} / ${sms.request.origin.name}`
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    sms.request
                                      ? `${sms.request.destination.province.name} / ${sms.request.destination.name}`
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    sms.request
                                      ? $getJalaliDateTime(
                                        sms.request.created_at,
                                      )
                                      : "-"
                                  }}
                                </td>
                                <td>
                                  {{
                                    sms.created_at
                                      ? $getJalaliDateTime(sms.created_at)
                                      : "-"
                                  }}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div v-else class="text-muted small">
                          پیامکی یافت نشد.
                        </div>
                      </div>
                    </div>

                    <!-- رانندگان دیگر -->
                    <div class="col-lg-6 mb-3">
                      <div class="card p-2 border rounded">
                        <h6 class="mb-2 text-secondary">رانندگان</h6>
                        <ul class="list-unstyled mb-0" v-if="otherDrivers.length">
                          <li v-for="(d, i) in otherDrivers" :key="i" class="small bold">
                            {{ d.name }} - موبایل: {{ d.user.phone }} - کدملی:
                            <b class="font-weight-bold">{{
                              d.user.national_code
                              }}</b>
                          </li>
                        </ul>
                        <div v-else class="text-muted small">
                          راننده دیگری ثبت نشده.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- تب اطلاعات -->
              <div role="tabpanel" id="tab-info" class="tab-pane">
                <div class="text-left mb-3">
                  <bita-bootbutton type="info" title="ویرایش اطلاعات" icon="fas fa-edit" btn-width="180px"
                    @click.native="openDriverEditModal" />
                </div>
                <div class="panel-body">
                  <bita-form ref="form">
                    <div slot="body">
                      <div class="row">
                        <div class="col-12">
                          <h5 class="section-title">
                            اطلاعات شخصی
                            <span v-if="driver.activation_code" class="text-muted text-sm">
                              ({{
                                driver && driver.user
                                  ? driver.user.activation_code
                                  : ""
                              }})
                            </span>
                          </h5>
                          <hr />
                        </div>
                        <bita-input disabled type="text" name="name" label="نام" :validation-container-class="colWidth"
                          input-class="form-control" v-model="driver.user.name" />
                        <bita-input disabled type="text" name="family" label="نام خانوادگی"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.user.family" />
                        <bita-input disabled type="text" name="national_code" label="کدملی"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.user.national_code" />
                        <bita-input disabled type="text" name="ssn_number" label="شماره شناسنامه"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.user.ssn_number" />
                        <bita-input disabled type="text" name="phone" label="شماره تماس"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.user.phone" />
                        <bita-input disabled type="text" name="postal_code" label="کد پستی"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.user.postal_code" />
                        <bita-textarea disabled label="آدرس" name="address" class="col-12"
                          inputClass="col-12 form-control" v-model="driver.user.address" />

                        <div class="col-12 mt-4">
                          <h5 class="section-title">اطلاعات خودرو و ناوگان</h5>
                          <hr />
                        </div>
                        <div :class="colWidth">
                          <plate-number-inputes :disable="true" v-if="driver.number_plate"
                            v-model="driver.number_plate" />
                        </div>
                        <bita-input disabled type="text" name="car_smartnumber" label="شماره هوشمند ماشین"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.car_smartnumber" />
                        <bita-input disabled type="text" name="driver_smartnumber" label="شماره هوشمند راننده"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.driver_smartnumber" />
                        <bita-input disabled type="text" name="certificate_number" label="شماره گواهینامه"
                          :validation-container-class="colWidth" input-class="form-control"
                          v-model="driver.certificate_number" />
                        <bita-select disabled name="vehicle_type" label="نوع ماشین"
                          :validation-container-class="colWidth" :data-source="vehicleType" data-text-field="name"
                          data-value-field="id" v-model="driver.vehicle_type_id" />
                      </div>
                    </div>
                  </bita-form>
                </div>
              </div>

              <!-- تب گزارش فعالیت -->
              <div role="tabpanel" id="tab-activity" class="tab-pane">
                <div class="panel-body">
                  <bita-grid ref="activityGrid" :columns="gridColumnsActivity" :read-data="readDataActivity"
                    :hasRow="false" />
                </div>
              </div>

              <!-- تب نوبت‌ها -->
              <div role="tabpanel" id="tab-tickets" class="tab-pane">
                <div class="panel-body">
                  <bita-grid ref="ticketsGrid" :columns="gridColumnsTickets" :read-data="readDataTickets"
                    :hasRow="false" />
                </div>
              </div>

              <!-- تب گزارش مالی -->
              <div role="tabpanel" id="tab-wallet" class="tab-pane">
                <div class="panel-body">
                  <div class="row mb-3">
                    <bita-datepicker type="date" validation-container-class="col-lg-4" label="از تاریخ"
                      inputClass="form-control" @change="loadDataWallet" v-model="filterWallet.fromDate" />
                    <bita-datepicker type="date" validation-container-class="col-lg-4" label="تا تاریخ"
                      inputClass="form-control" @change="loadDataWallet" v-model="filterWallet.toDate" />
                    <bita-select label="نوع" validation-container-class="col-lg-4" input-class="form-control"
                      :data-source="statuses" data-text-field="name" data-value-field="id" v-model="filterWallet.status"
                      @change="loadDataWallet" />
                  </div>
                  <bita-grid ref="walletGrid" :columns="gridColumnsWallet" :read-data="readDataWallet"
                    :grid-server-side="true" schema-total="total" schema-data="data" :server-paging="true" :batch="true"
                    :resizable="true" :page-size="pageSize" :current-page="currentPage" />
                </div>
              </div>

              <!-- تب نقشه -->
              <div role="tabpanel" id="tab-map" class="tab-pane">
                <div class="panel-body">
                  <div class="map-container">
                    <div id="map"></div>
                  </div>
                </div>
              </div>

              <!-- تب وضعیت بارها -->
              <div role="tabpanel" id="tab-logs" class="tab-pane">
                <div class="panel-body">
                  <div class="text-left mb-3">
                    <bita-bootbutton type="warning" title="رفع محدودیت رزرو راننده" btn-width="200px"
                      @click.native="removeAccess" />
                  </div>
                  <div class="row mb-3">
                    <bita-datepicker type="date" validation-container-class="col-lg-4" label="از تاریخ"
                      inputClass="form-control" @change="loadDataLog" v-model="filtersLog.fromDate" />
                    <bita-datepicker type="date" validation-container-class="col-lg-4" label="تا تاریخ"
                      inputClass="form-control" @change="loadDataLog" v-model="filtersLog.toDate" />
                    <bita-select label="نوع لاگ" validation-container-class="col-lg-4" input-class="form-control"
                      :data-source="statuses" data-text-field="name" data-value-field="id" v-model="filtersLog.type"
                      @change="loadDataLog" />
                  </div>
                  <bita-grid ref="logsGrid" :columns="gridColumnsLog" :read-data="readDataLog" :hasRow="false" />
                </div>
              </div>

              <!-- تب پیامک‌ها -->
              <div role="tabpanel" id="tab-sms" class="tab-pane">
                <div class="panel-body">
                  <div class="mb-5">
                    <h5 class="section-title text-center text-primary mb-3">
                      سالن‌های فعال برای پیامک
                    </h5>
                    <div v-if="salons.length > 0" class="table-responsive">
                      <table class="table table-bordered table-striped text-center">
                        <thead class="thead-light">
                          <tr>
                            <th>نام سالن</th>
                            <th width="100px">عملیات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="salon in salons" :key="salon.id">
                            <td>{{ salon.name }}</td>
                            <td>
                              <button class="btn btn-sm btn-outline-danger border-0" @click="onDeleteNotif(salon)"
                                title="حذف">
                                <i class="fas fa-times"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="alert alert-warning text-center">
                      این راننده در هیچ سالنی برای دریافت پیامک فعال نیست.
                    </div>
                  </div>

                  <div>
                    <h5 class="section-title text-center text-info mb-3">
                      آخرین پیامک‌های ارسالی
                    </h5>
                    <div v-if="notifications.length > 0" class="table-responsive">
                      <table class="table table-bordered table-striped text-center text-sm">
                        <thead class="thead-light">
                          <tr>
                            <th>نوع</th>
                            <th>فعالیت</th>
                            <th>سالن</th>
                            <th>مبدا</th>
                            <th>مقصد</th>
                            <th>تاریخ ایجاد بار</th>
                            <th>تاریخ ارسال</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="notif in notifications" :key="notif.id">
                            <td>{{ notif.type }}</td>
                            <td>{{ notif.action }}</td>
                            <td>
                              {{
                                notif.request ? notif.request.salon.name : "-"
                              }}
                            </td>
                            <td>
                              {{
                                notif.request
                                  ? `${notif.request.origin.province.name} / ${notif.request.origin.name}`
                                  : "-"
                              }}
                            </td>
                            <td>
                              {{
                                notif.request
                                  ? `${notif.request.destination.province.name} / ${notif.request.destination.name}`
                                  : "-"
                              }}
                            </td>
                            <td>
                              {{
                                notif.request
                                  ? $getJalaliDateTime(notif.request.created_at)
                                  : "-"
                              }}
                            </td>
                            <td>
                              {{
                                notif.created_at
                                  ? $getJalaliDateTime(notif.created_at)
                                  : "-"
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else class="alert alert-secondary text-center">
                      تاریخچه پیامکی یافت نشد.
                    </div>
                  </div>
                </div>
              </div>

              <!-- تب اولویت‌ها -->
              <div role="tabpanel" id="tab-priorities" class="tab-pane">
                <div class="panel-body">
                  <div v-if="priorities.length > 0" class="table-responsive">
                    <table class="table table-bordered table-striped text-center">
                      <thead class="thead-light">
                        <tr>
                          <th>سالن (ترمینال)</th>
                          <th>اولویت</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in priorities" :key="item.id">
                          <td>{{ item.name }} ({{ item.terminal_name }})</td>
                          <td>
                            <span class="badge badge-primary px-3 py-2">{{
                              item.priority
                              }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="alert alert-secondary text-center">
                    اولویت ثبت شده‌ای وجود ندارد.
                  </div>
                </div>
              </div>

              <!-- تب رانندگان -->
              <div role="tabpanel" id="tab-drivers" class="tab-pane">
                <div class="panel-body">
                  <table class="table">
                    <thead>
                      <tr class="text-center">
                        <th>#</th>
                        <th>راننده</th>
                        <th>شماره هوشمند ماشین</th>
                        <th>شماره پلاک خودرو</th>
                        <th>کدملی</th>
                        <th>شماره موبایل</th>
                        <th>تاریخ ایجاد</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(driver, index) in drivers" :key="index" class="text-center">
                        <td>{{ index + 1 }}</td>
                        <td>{{ driver.name }}</td>
                        <td>{{ driver.car_smartnumber }}</td>
                        <td>{{ driver.number_plate }}</td>
                        <td>
                          {{
                            driver && driver.user
                              ? driver.user.national_code
                              : ""
                          }}
                        </td>
                        <td>
                          {{ driver && driver.user ? driver.user.phone : "" }}
                        </td>
                        <td>{{ $getJalaliDateTime(driver.created_at) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div role="tabpanel" id="tab-activity-history" class="tab-pane">
                <div class="panel-body">

                  <!-- هدر تب -->
                  <div class="d-flex justify-content-between align-items-center mb-3"
                    style="flex-direction: row-reverse;">
                    <button type="button" class="btn btn-primary" @click="openDriverActivityModal">
                      <i class="fas fa-plus"></i>
                      ثبت فعالیت
                    </button>

                    <h5 class="mb-0">
                      تاریخچه فعالیت راننده
                    </h5>
                  </div>

                  <!-- جدول -->
                  <bita-grid ref="driverActivityGrid" :columns="gridColumnsDriverActivity"
                    :read-data="readDataDriverActivity" :grid-server-side="true" schema-total="total" schema-data="data"
                    :server-paging="true" :page-size="20" :hasRow="false" :resizable="true" />

                </div>
              </div>

            </div>
          </div>
          <div v-else-if="currentVoipPhone || currentVoipLogId" class="card mt-3 border-warning">
            <div class="card-header d-flex justify-content-between align-items-center flex-wrap" style="gap: 8px">
              <h5 class="mb-0 text-warning">شماره ناشناس (راننده ثبت نشده)</h5>
              <span class="font-weight-bold">شماره تماس: {{ currentVoipPhone || mobile || "-" }}</span>
            </div>
            <div class="card-body">
              <div class="alert alert-warning">
                برای این شماره راننده‌ای پیدا نشد، اما می‌توانید مشاهده شماره و سایر فعالیت‌های اپراتور را ثبت کنید.
              </div>
              <div class="d-flex justify-content-between align-items-center flex-wrap mb-3" style="gap: 8px">
                <h6 class="mb-0">تاریخچه فعالیت این شماره</h6>
                <button type="button" class="btn btn-primary" @click="openDriverActivityModal">
                  <i class="fas fa-plus ml-1"></i>
                  ثبت فعالیت
                </button>
              </div>
              <bita-grid ref="driverActivityGrid" :columns="gridColumnsDriverActivity"
                :read-data="readDataDriverActivity" :grid-server-side="true" schema-total="total" schema-data="data"
                :server-paging="true" :page-size="20" :hasRow="false" :resizable="true" />
            </div>
          </div>
        </div>

        <!-- ستون سمت راست: لیست شماره‌های اخیر -->
        <div class="col-lg-2 col-md-4">
          <div class="recent-phones-box">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">شماره‌های جدید</h6>
              <button class="btn btn-sm btn-outline-success" @click="refreshPhoneNumbers">
                بروزرسانی
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="clearRecentPhones"
                :disabled="recentPhones.length === 0">
                حذف همه
              </button>
            </div>

            <transition-group name="list" tag="div" class="recent-phones-list">
              <div class="phone-card" v-for="(item, index) in recentPhones" :class="{
                'is-selected-phone': mobile == item.phone,
                'not-found': notFoundMobiles.includes(item.phone),
              }" :key="item.id" @click="selectPhone(item.phone)">
                <div class="phone-info">
                  <i class="fas fa-phone-alt text-success ml-2"></i>
                  <span class="phone-text">{{ item.phone }}</span>
                </div>
                <button class="btn btn-sm btn-link text-danger" @click.stop="removePhone(index)">
                  <i class="fas fa-times"></i>
                </button>
              </div>
            </transition-group>

            <div v-if="recentPhones.length === 0" class="empty-list">
              هنوز شماره‌ای ثبت نشده است.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="driver-activity-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">
              ثبت فعالیت راننده
            </h5>

            <button type="button" class="close" @click="closeDriverActivityModal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">

            <!-- راننده -->
            <div class="form-group">
              <label>
                راننده
              </label>

              <input type="text" class="form-control" :value="driver && driver.user
                ? `${driver.user.name || ''} ${driver.user.family || ''} - ${driver.user.phone || 'بدون شماره تماس'}`
                : (currentVoipPhone || mobile
                  ? `شماره ناشناس: ${currentVoipPhone || mobile}`
                  : 'تماس ناشناس')
                " disabled />
            </div>

            <!-- انتخاب نوع فعالیت -->
            <div class="form-group">
              <label>
                فعالیت
                <span class="text-danger">*</span>
              </label>

              <div class="d-flex align-items-center flex-wrap" style="gap: 8px">
                <!-- فهرست فعالیت‌ها -->
                <select v-model="activityForm.activity_slug" class="form-control" style="flex: 1; min-width: 180px"
                  :disabled="isActivityModalLoading || isSavingActivityType">
                  <option value="">انتخاب فعالیت</option>

                  <option v-for="activity in driverActivities" :key="activity.id" :value="activity.slug">
                    {{ activity.label }}
                  </option>
                </select>

                <!-- دکمه افزودن نوع جدید -->
                <button type="button" class="btn btn-outline-primary" @click="toggleNewActivityForm"
                  :disabled="isActivityModalLoading || isSavingActivityType">
                  <i class="fas fa-plus ml-1"></i>
                  {{ showNewActivityForm ? "انصراف" : "نوع جدید" }}
                </button>
              </div>
            </div>

            <!-- فرم افزودن نوع فعالیت -->
            <div v-if="showNewActivityForm" class="form-group border rounded p-3 mt-3">
              <label for="new-activity-label">
                عنوان نوع فعالیت جدید
                <span class="text-danger">*</span>
              </label>

              <input id="new-activity-label" v-model.trim="newActivityLabel" type="text" class="form-control mb-2"
                maxlength="120" placeholder="مثلاً: هماهنگی با باربری" :disabled="isSavingActivityType"
                @keyup.enter="createDriverActivityType" />

              <button type="button" class="btn btn-success" @click="createDriverActivityType"
                :disabled="isSavingActivityType || !newActivityLabel.trim()">
                <span v-if="isSavingActivityType" class="spinner-border spinner-border-sm ml-1"></span>

                <i v-else class="fas fa-plus ml-1"></i>

                افزودن فعالیت
              </button>

              <small class="text-muted d-block mt-2">
                پس از ذخیره، نوع فعالیت به فهرست مشترک اضافه می‌شود.
              </small>
            </div>

            <!-- توضیحات -->
            <div class="form-group">
              <label>
                توضیحات
              </label>

              <textarea v-model="activityForm.description" class="form-control" rows="5" maxlength="5000"
                placeholder="توضیحات فعالیت را وارد کنید..." :disabled="isActivityModalLoading"></textarea>
            </div>

            <div v-if="!currentVoipLogId && driver && driver.id" class="alert alert-info">
              تماس جاری متصل نیست؛ فعالیت بر اساس شناسه راننده ثبت می‌شود.
            </div>
            <div v-else-if="!driver && (currentVoipPhone || mobile)" class="alert alert-warning">
              راننده‌ای با این شماره در سامانه ثبت نشده است؛ فعالیت به‌عنوان تماس/شماره ناشناس ذخیره می‌شود.
            </div>

          </div>

          <div class="modal-footer">

            <button type="button" class="btn btn-secondary" @click="closeDriverActivityModal"
              :disabled="isActivityModalLoading">
              انصراف
            </button>

            <button type="button" class="btn btn-primary" @click="saveDriverActivity" :disabled="isActivityModalLoading ||
              !activityForm.activity_slug ||
              (!currentVoipLogId && !(driver && driver.id))
              ">
              <span v-if="isActivityModalLoading" class="spinner-border spinner-border-sm ml-1"></span>

              ثبت فعالیت
            </button>

          </div>

        </div>
      </div>
    </div>

    <form-modal modal-id="edit-modal" title="ویرایش" ref="editModal" :isLoading="isLoading" :props-data="updateForm"
      @on-submit="handleEdit" />

    <driver-form-modal ref="driverEditModal" :isLoading="isLoadingModal" :props-data="driverUpdateForm"
      :props-vehicle-type-parent="vehicleTypeParent" :props-vehicle-type="vehicleType" modal-id="driver-edit-modal"
      title="ویرایش اطلاعات راننده" @on-submit="handleDriverEdit" />
    <cancel-request ref="cancelRequestRef" :props-silver="isSilver" @on-submit="handleCancelRequest" />
  </div>
</template>

<script>
import PlateNumberInputes from "./../../../components/PlateNumberInputs";
import DriversForm from "./../../../views/management/drivers/From";
import L, { icon } from "leaflet";
import StatusModal from "../requests/components/StatusModal.vue";
import RequestDetailForm from "../request-detail/Form.vue";
import CancelRequest from "../requests/CancelRequest.vue";

export default {
  components: {
    "driver-form-modal": DriversForm,
    "form-modal": RequestDetailForm,
    PlateNumberInputes,
    StatusModal,
    CancelRequest,
  },
  data() {
    return {
      requestVersion: 0,
      driverSearchVersion: 0,
      updateForm: {},
      isLoadingModal: false,
      driverUpdateForm: {},
      isLoading: false,
      driver: null,
      drivers: [],
      logs: [],
      map: null,
      mobile: "",
      nationalCode: "",
      notFoundMobiles: [],
      priorities: [],
      tickets: [],
      notifications: [],
      salons: [],
      vehicleTypeParent: [],
      vehicleType: [],
      filtersLog: {},
      filterWallet: {},
      pageSize: 0,
      currentPage: 0,
      total_amount: 0,
      colWidth: "col-lg-4 col-md-6 col-sm-12",
      currentVoipLogId: null,
      currentVoipPhone: null,

      driverActivities: [],
      isActivityModalLoading: false,

      activityForm: {
        activity_slug: "",
        description: "",
      },
      showNewActivityForm: false,
      newActivityLabel: "",
      isSavingActivityType: false,
      statuses: [
        { id: 28, name: "شارژ کیف پول" },
        { id: 45, name: "خرید بلیط" },
        { id: 60, name: "پیامک اعلام بار" },
        { id: 61, name: "تسویه شده" },
      ],
      breadCrumbs: [
        { title: "صفحه اصلی", link: "/" },
        { title: "مدیریت راننده‌ها", link: "/management/drivers" },
        { title: "پروفایل جامع راننده", link: "#", active: true },
      ],
      gridColumnsWallet: [
        { title: "#", template: this.$getTemplate, width: "40px" },
        {
          field: "tracking_code",
          title: "کد‌پیگیری",
          template: (e) => e.tracking_code || " - ",
          width: 110,
        },
        {
          field: "amount",
          title: this.$currencyLabel("مبلغ"),
          footerTemplate: () =>
            `جمع کل: ${this.$thousandSeprator(this.total_amount)}`,
          template: (e) => {
            const iconHtml = e.payment_state
              ? '<i class="fas fa-sort-up text-success"></i>'
              : '<i class="fas fa-sort-down text-danger"></i>';
            return e.amount
              ? `${iconHtml} ${this.$thousandSeprator(e.amount)}`
              : " - ";
          },
          width: 150,
        },
        { field: "type_name", title: "نوع", width: 110 },
        {
          field: "description",
          title: "توضیحات",
          template: (e) => e.description || "-",
          width: 150,
        },
        {
          field: "created_at",
          title: "تاریخ",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "",
          width: 130,
        },
      ],
      recentPhones: [],
      maxRecent: 50,
      phoneInterval: null,
    };
  },
  computed: {
    isSilver() {
      const roles =
        this.$acl && Array.isArray(this.$acl.roles)
          ? this.$acl.roles
          : [];

      return roles.includes("silver-subscription");
    },
    gridColumnsDriverActivity() {
      return [
        {
          title: "#",
          template: (e) => e.id || "-",
          width: "60px",
        },

        {
          title: "فعالیت",
          template: (e) =>
            e.activity?.label || "-",
          width: "180px",
        },

        {
          title: "شماره تماس",
          template: (e) =>
            e.phone || "-",
          width: "130px",
        },

        {
          title: "اپراتور",
          template: (e) =>
            e.operator?.name || "سیستم",
          width: "160px",
        },

        {
          title: "توضیحات",
          template: (e) =>
            e.description || "-",
          width: "250px",
        },

        {
          title: "تاریخ",
          template: (e) =>
            e.created_at
              ? this.$getJalaliDateTime(
                e.created_at
              )
              : "-",
          width: "150px",
        },
      ];
    },
    lastLoads() {
      return (this.logs || []).slice(0, 5);
    },

    lastCanceledTickets() {
      return (this.tickets || []).slice(0, 5);
    },

    lastSms() {
      return (this.notifications || []).slice(0, 5);
    },

    otherDrivers() {
      return (this.drivers || []).slice(0, 5);
    },
    // --------------------
    gridColumnsLog() {
      return [
        { title: "مبدا", template: (e) => e.request.origin_name || "-" },
        { title: "مقصد", template: (e) => e.request.destination_name || "-" },
        {
          title: "تاریخ بارگیری",
          template: (e) =>
            e.request.loading_at
              ? this.$getJalaliDate(e.request.loading_at)
              : "-",
        },
        { title: "وضعیت", template: (e) => e.state || "-" },
      ];
    },
    gridColumnsTickets() {
      return [
        {
          title: "ترمینال",
          template: (e) => e.terminal_name || "-",
          width: "50px",
        },
        {
          title: "سالن",
          template: (e) => this.ticketSalonNameText(e),
          width: "90px"
        },
        {
          title: "وضعیت",
          template: (e) => (e.status ? this.statusText(e) : "-"),
          width: "70px",
        },
        {
          title: "تاریخ انقضاء",
          template: (e) =>
            e.expire_at ? this.$getJalaliDateTime(e.expire_at) : "-",
          width: "90px",
        },
        {
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "-",
          width: "90px",
        },
      ];
    },
    gridColumnsActivity() {
      return [
        {
          title: "مبدا",
          template: (e) => e.request.origin_name || "-",
          width: "100px",
        },
        {
          title: "مقصد",
          template: (e) => e.request.destination_name || "-",
          width: "100px",
        },
        {
          title: "تاریخ بارگیری",
          template: (e) =>
            e.request.loading_at
              ? this.$getJalaliDate(e.request.loading_at)
              : "-",
          width: "100px",
        },
        {
          title: "سالن",
          template: (e) => e.request.salon_name || "-",
          width: "130px",
        },
        {
          title: "وضعیت",
          template: (e) => e.status_text || "-",
          width: "100px",
        },
        {
          title: "تاریخ ایجاد",
          template: (e) =>
            e.created_at ? this.$getJalaliDateTime(e.created_at) : "-",
          width: "140px",
        },
      ];
    },
  },
  mounted() {
    this.fetchDriverActivities();

    this.phoneInterval = setInterval(() => {
      this.refreshPhoneNumbers();
    }, 15000);
  },
  beforeDestroy() {
    if (this.phoneInterval) {
      clearInterval(this.phoneInterval);
      this.phoneInterval = null;
    }
  },
  methods: {
    logAutomaticActivity(
      activitySlug,
      description = null,
      driverId = null
    ) {
      if (!activitySlug) {
        return;
      }

      // برای راننده ثبت‌شده driver_id و برای شماره ناشناس phone/voip_log_id ارسال می‌شود.
      const resolvedDriverId =
        driverId || (this.driver && this.driver.id) || null;
      const voipLogId = this.currentVoipLogId || null;
      const phone =
        (this.driver && this.driver.user && this.driver.user.phone) ||
        this.currentVoipPhone ||
        (this.mobile || "").trim() ||
        null;

      if (!resolvedDriverId && !voipLogId && !phone) {
        console.warn(
          "Driver activity was not logged: driver_id, voip_log_id and phone are missing."
        );
        return;
      }

      this.$persistClient(
        "post",
        "drivers/activity-logs",
        {
          activity_slug: activitySlug,
          description: description,
          driver_id: resolvedDriverId,
          voip_log_id: voipLogId,
          phone: phone,
        }
      )
        .then(() => {
          if (
            this.$refs.driverActivityGrid
          ) {
            this.$refs.driverActivityGrid.loadDataSource();
          }
        })
        .catch((error) => {
          console.error(
            "Driver activity log failed:",
            {
              status: error.response?.status,
              response: error.response?.data,
              url: error.config?.url,
              requestData: error.config?.data,
            }
          );
        });
    },

    cancelLoad(item) {
      const request = item && item.request;

      if (!request || !request.id) {
        this.$izitoast(
          "error",
          "خطا",
          "اطلاعات درخواست بار برای کنسل کردن پیدا نشد."
        );

        return;
      }

      this.$refs.cancelRequestRef.init(request);
    },

    handleCancelRequest({ request, type }) {
      if (!request || !request.id) {
        this.$izitoast(
          "error",
          "خطا",
          "شناسه درخواست بار معتبر نیست."
        );

        return;
      }

      const cancelType = type === "all" ? "all" : "free";

      this.$persistClient(
        "delete",
        `requests/${request.id}?cancel=${cancelType}`
      )
        .then((res) => {
          this.$izitoast(
            "success",
            "عملیات موفق",
            res.data.message || "درخواست بار با موفقیت کنسل شد."
          );

          this.logAutomaticActivity(
            "load_cancelled",
            `کنسل کردن درخواست بار با شناسه ${request.id}`
          );

          this.refreshLastLoads();
        })
        .catch((error) => {
          this.$izitoast(
            "error",
            "خطا",
            error.response?.data?.message ||
            "کنسل کردن درخواست بار انجام نشد."
          );
        });
    },

    refreshLastLoads() {
      if (this.$refs.logsGrid) {
        this.$refs.logsGrid.loadDataSource();
        return;
      }

      if (!this.driver || !this.driver.id) {
        return;
      }

      const url = this.$makeQueryString(
        `drivers/${this.driver.id}/request-tickets`,
        this.filtersLog
      );

      this.$persistClient("get", url)
        .then((res) => {
          this.logs = res.data || [];
        })
        .catch((error) => {
          console.error("Refreshing driver loads failed:", error);
        });
    },

    toggleNewActivityForm() {
      this.showNewActivityForm = !this.showNewActivityForm;

      if (!this.showNewActivityForm) {
        this.newActivityLabel = "";
      }
    },
    createDriverActivityType() {
      const label = (this.newActivityLabel || "").trim();

      if (!label) {
        this.$izitoast(
          "warning",
          "اخطار",
          "لطفاً عنوان نوع فعالیت را وارد کنید."
        );

        return;
      }

      if (this.isSavingActivityType) {
        return;
      }

      this.isSavingActivityType = true;

      this.$persistClient(
        "post",
        "driver-activities",
        {
          label: label,
        }
      )
        .then((res) => {
          const activity = res.data && res.data.data;

          if (!activity || !activity.slug) {
            throw new Error(
              "پاسخ API شامل شناسه نوع فعالیت نیست."
            );
          }

          const index = this.driverActivities.findIndex(
            (item) => item.slug === activity.slug
          );

          if (index === -1) {
            this.driverActivities.push(activity);
          } else {
            this.$set(
              this.driverActivities,
              index,
              activity
            );
          }

          this.activityForm.activity_slug = activity.slug;

          this.showNewActivityForm = false;
          this.newActivityLabel = "";

          this.$izitoast(
            "success",
            "عملیات موفق",
            res.data.message ||
            "نوع فعالیت با موفقیت اضافه شد."
          );
        })
        .catch((error) => {
          console.error(
            "Creating driver activity type failed:",
            error
          );

          this.$izitoast(
            "error",
            "خطا",
            error.response?.data?.message ||
            error.message ||
            "افزودن نوع فعالیت انجام نشد."
          );
        })
        .finally(() => {
          this.isSavingActivityType = false;
        });
    },
    openDriverEditModal() {
      if (!this.driver || !this.driver.user) {
        this.$izitoast("warning", "اخطار", "راننده‌ای انتخاب نشده است.");
        return;
      }

      // ساخت آبجکت داده برای فرم ویرایش
      this.driverUpdateForm = {
        id: this.driver.id,
        name: this.driver.user.name,
        family: this.driver.user.family,
        national_code: this.driver.user.national_code,
        ssn_number: this.driver.user.ssn_number,
        phone: this.driver.user.phone,
        postal_code: this.driver.user.postal_code,
        address: this.driver.user.address,
        number_plate: this.driver.number_plate,
        car_smartnumber: this.driver.car_smartnumber,
        driver_smartnumber: this.driver.driver_smartnumber,
        certificate_number: this.driver.certificate_number,
        activation_code: this.driver.user.activation_code,
        vehicle_type_id: this.driver.vehicle_type_id,
        vehicle_type_parent_id: this.driver.vehicle_type
          ? this.driver.vehicle_type.parent_id
          : null,
      };

      // باز کردن مودال
      this.$toggleModal("#driver-edit-modal");
    },
    handleDriverEdit(data) {
      this.isLoadingModal = true;

      this.$persistClient(
        "patch",
        `drivers/${data.id}`,
        data
      )
        .then((res) => {
          this.$izitoast(
            "success",
            "عملیات موفق",
            res.data.message
          );

          this.$toggleModal(
            "#driver-edit-modal"
          );

          if (
            data.phone !== this.mobile ||
            data.national_code !==
            this.nationalCode
          ) {
            this.mobile = data.phone;
            this.nationalCode =
              data.national_code;
          }

          this.logAutomaticActivity(
            "driver-edit",
            "ویرایش اطلاعات راننده توسط اپراتور"
          );

          this.searchMobile();
        })
        .catch((error) => {
          this.$izitoast(
            "error",
            "خطا",
            error.response?.data?.message ||
            "خطایی رخ داد."
          );
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },
    refreshPhoneNumbers() {
      this.$persistClient("get", "voip?token=Emordad26@5")
        .then(({ data }) => {
          if (data.data.length > 0) {
            data.data.forEach((p) => {
              this.addRecentPhone(
                p.phone,
                p.id || p.voip_log_id
              );
            });
          }
        })
        .catch((error) => console.error(error));
    },
    edit(requestDetail) {
      this.updateForm = {
        id: requestDetail.id,
      };

      this.statusChangeModalEdit();
    },
    statusChangeModalEdit() {
      this.$toggleModal("#edit-modal");
    },
    handleEdit(data) {
      this.isLoading = true;

      this.$persistClient("patch", `request-details/${data.id}/states`, data)
        .then((res) => {
          this.$izitoast("success", "عملیات موفق", res.data.message);

          this.updateForm = {
            state_id: 0,
          };

          this.$refs.editModal.reset();

          this.statusChangeModalEdit();
          this.logAutomaticActivity(
            "request-status-changed",
            `تغییر وضعیت بار با شناسه ${data.id}`
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getVehicleTypeName(id) {
      const v = (this.vehicleType || []).find((x) => x.id === id);
      return v ? v.name : "-";
    },
    fetchDriverActivities() {
      this.$persistClient(
        "get",
        "driver-activities"
      )
        .then((res) => {
          this.driverActivities =
            res.data?.data || [];
        })
        .catch(() => {
          this.driverActivities = [];
        });
    },

    searchMobile() {
      const mobile = (this.mobile || "").trim();
      const nationalCode = (this.nationalCode || "").trim();

      if (!mobile && !nationalCode) {
        this.$izitoast(
          "warning",
          "اخطار",
          "شماره موبایل یا کد ملی را وارد کنید."
        );
        return;
      }

      const requestVersion = ++this.driverSearchVersion;

      ///////////////////
      const recentPhone = mobile
        ? this.recentPhones.find(
            (item) => item.phone === mobile
          )
        : null;

      this.currentVoipLogId =
        recentPhone && recentPhone.voip_log_id
          ? recentPhone.voip_log_id
          : null;

      this.currentVoipPhone =
        (recentPhone && recentPhone.phone) || mobile || null;


      this.resetDriverData();

      this.fetchDriverByMobile(
        mobile,
        nationalCode,
        requestVersion
      );

      this.fetchBaseData();
    },
    resetDriverData() {
      this.driver = null;

      this.drivers = [];
      this.logs = [];
      this.tickets = [];
      this.notifications = [];
      this.salons = [];
      this.priorities = [];

      this.updateForm = {};
      this.driverUpdateForm = {};

      this.total_amount = 0;
      this.pageSize = 0;
      this.currentPage = 0;

      this.filtersLog = {
        fromDate: null,
        toDate: null,
        type: null,
      };

      this.filterWallet = {
        fromDate: null,
        toDate: null,
        status: null,
      };

      this.activityForm = {
        activity_slug: "",
        description: "",
      };

      if (this.map) {
        this.map.remove();
        this.map = null;
      }
    },

    saveDriverActivity() {
      if (!this.activityForm.activity_slug) {
        this.$izitoast(
          "warning",
          "اخطار",
          "لطفاً فعالیت را انتخاب کنید."
        );

        return;
      }

      const driverId = this.driver && this.driver.id
        ? this.driver.id
        : null;
      const voipLogId = this.currentVoipLogId || null;
      const phone =
        (this.driver && this.driver.user && this.driver.user.phone) ||
        this.currentVoipPhone ||
        (this.mobile || "").trim() ||
        null;

      if (!driverId && !voipLogId && !phone) {
        this.$izitoast(
          "warning",
          "اخطار",
          "شماره تماس، راننده یا شناسه تماس معتبر پیدا نشد."
        );
        return;
      }

      this.isActivityModalLoading = true;

      this.$persistClient(
        "post",
        "drivers/activity-logs",
        {
          activity_slug: this.activityForm.activity_slug,
          description: this.activityForm.description || null,
          driver_id: driverId,
          voip_log_id: voipLogId,
          phone: phone,
        }
      )
        .then((res) => {
          this.$izitoast(
            "success",
            "عملیات موفق",
            res.data.message ||
            "فعالیت با موفقیت ثبت شد."
          );

          this.closeDriverActivityModal();

          if (
            this.$refs.driverActivityGrid
          ) {
            this.$refs.driverActivityGrid.loadDataSource();
          }
        })
        .catch((error) => {
          this.$izitoast(
            "error",
            "خطا",
            error.response?.data?.message ||
            "ثبت فعالیت انجام نشد."
          );
        })
        .finally(() => {
          this.isActivityModalLoading = false;
        });
    },
    loadDriverActivityHistory() {
      this.$nextTick(() => {
        if (
          this.$refs.driverActivityGrid
        ) {
          this.$refs.driverActivityGrid.loadDataSource();
        }
      });
    },
    readDataDriverActivity(e) {
      const pageSize = e.data?.pageSize || 20;
      const page = e.data?.page || 1;
      const driverId = this.driver && this.driver.id
        ? this.driver.id
        : null;
      const phone =
        (this.driver && this.driver.user && this.driver.user.phone) ||
        this.currentVoipPhone ||
        (this.mobile || "").trim() ||
        null;
      const voipLogId = this.currentVoipLogId || null;

      if (!driverId && !phone && !voipLogId) {
        e.success({ data: [], total: 0 });
        return;
      }

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("page_size", pageSize);

      if (driverId) params.append("driver_id", driverId);
      if (phone) params.append("phone", phone);
      if (voipLogId) params.append("voip_log_id", voipLogId);

      const url = `drivers/activity-report?${params.toString()}`;

      this.$persistClient("get", url)
        .then((res) => {
          e.success(res.data);
        })
        .catch(() => {
          e.success({
            data: [],
            total: 0,
          });
        });
    },



    fetchDriverByMobile(mobile, nationalCode, requestVersion) {
      this.isLoading = true;

      let url = "";

      if (mobile) {
        url = `drivers?phone=${mobile}&include=user,user.balance,vehicle_type`;
      } else if (nationalCode) {
        url = `drivers?national_code=${nationalCode}&include=user,user.balance,vehicle_type`;
      }

      this.$persistClient("get", url)
        .then((res) => {
          if (requestVersion !== this.driverSearchVersion) {
            return;
          }

          if (res.data && res.data.length > 0) {
            this.driver = res.data[0];

            this.logAutomaticActivity(
              "driver-profile-view",
              "مشاهده پروفایل راننده توسط اپراتور",
              this.driver.id
            );

            this.prepareEditForm();

            this.fetchAdditionalData();

            this.initMapData();
            if (this.driver.number_plate)
              this.fetchDrivers(
                this.driver.number_plate,
                requestVersion
              );
          } else {
            this.driver = null;
            this.drivers = [];

            this.notFoundMobiles.push(mobile || nationalCode);

            if (mobile) {
              this.currentVoipPhone = mobile;
              this.logAutomaticActivity(
                "driver-profile-view",
                `جست‌وجوی پروفایل برای شماره ناشناس ${mobile}`,
                null
              );

              this.$izitoast(
                "warning",
                "شماره ناشناس",
                "راننده‌ای با این شماره ثبت نشده است؛ می‌توانید برای این شماره فعالیت ثبت کنید."
              );
            } else {
              this.$izitoast(
                "error",
                "خطا",
                "راننده‌ای با این کد ملی یافت نشد."
              );
            }
          }
        })
        .catch((error) => {
          if (requestVersion !== this.driverSearchVersion) {
            return;
          }

          // بعضی APIها برای شماره‌ای که راننده ندارد، به‌جای آرایه خالی 404 برمی‌گردانند.
          if (mobile && error.response?.status === 404) {
            this.driver = null;
            this.drivers = [];
            this.currentVoipPhone = mobile;
            this.notFoundMobiles.push(mobile);

            this.logAutomaticActivity(
              "driver-profile-view",
              `جست‌وجوی پروفایل برای شماره ناشناس ${mobile}`,
              null
            );

            this.$izitoast(
              "warning",
              "شماره ناشناس",
              "راننده‌ای با این شماره ثبت نشده است؛ می‌توانید برای این شماره فعالیت ثبت کنید."
            );
            return;
          }

          this.$izitoast(
            "error",
            "خطا",
            error.response?.data?.message ||
            "دریافت اطلاعات راننده ناموفق بود."
          );
        })
        .finally(() => {
          if (requestVersion === this.driverSearchVersion) {
            this.isLoading = false;
          }
        });
    },
    fetchDrivers(plate, requestVersion) {
      if (!plate) {
        this.drivers = [];
        return;
      }

      const url = this.$makeQueryString(`vehicles/${plate}`);

      this.$persistClient("get", url)
        .then((res) => {
          if (requestVersion !== this.driverSearchVersion) {
            return;
          }

          this.drivers = res.data.data || [];
        })
        .catch(() => {
          if (requestVersion === this.driverSearchVersion) {
            this.drivers = [];
          }
        });
    },

    fetchAdditionalData() {
      if (!this.driver || !this.driver.user) {
        return;
      }

      const driverId = this.driver.id;
      const userId = this.driver.user.id;

      // بررسی می‌کند که راننده فعلی هنوز همان راننده درخواست باشد.
      const isCurrentDriver = () => {
        return (
          this.driver &&
          this.driver.id === driverId &&
          this.driver.user &&
          this.driver.user.id === userId
        );
      };

      // سالن‌های فعال برای پیامک
      this.$persistClient(
        "get",
        `notification-settings?user_id=${userId}`
      )
        .then((res) => {
          if (!isCurrentDriver()) {
            return;
          }

          this.salons = res.data.data || [];
        })
        .catch(() => {
          if (isCurrentDriver()) {
            this.salons = [];
          }
        });

      // تاریخچه پیامک‌ها
      this.$persistClient(
        "get",
        `drivers/${userId}/notifications`
      )
        .then((res) => {
          if (!isCurrentDriver()) {
            return;
          }

          this.notifications = res.data.data || [];
        })
        .catch(() => {
          if (isCurrentDriver()) {
            this.notifications = [];
          }
        });

      // اولویت‌های راننده
      this.$persistClient(
        "get",
        `drivers/${userId}/salons`
      )
        .then((res) => {
          if (!isCurrentDriver()) {
            return;
          }

          this.priorities = res.data || [];
        })
        .catch(() => {
          if (isCurrentDriver()) {
            this.priorities = [];
          }
        });
    },
    fetchBaseData() {
      this.$persistClient("get", `vehicle-types?filter[parent]=0`).then(
        (res) => {
          this.vehicleTypeParent = res.data;
        },
      );
    },
    prepareEditForm() {
      if (this.driver.vehicle_type.parent_id) {
        this.$persistClient(
          "get",
          `vehicle-types?filter[parent]=${this.driver.vehicle_type.parent_id}`,
        ).then((res) => {
          this.vehicleType = res.data;
        });
      }
    },
    ticketExpireAtTimestamp(value) {
      if (!value) {
        return null;
      }

      const timestamp = Date.parse(value);

      return Number.isFinite(timestamp) ? timestamp : null;
    },

    ticketSalonNameText(ticket) {
      const salonName = String(ticket.salon_name || "-").replace(
        /[&<>"']/g,
        (char) => {
          const entities = {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          };

          return entities[char];
        }
      );

      const expireAt = this.ticketExpireAtTimestamp(ticket.expire_at);
      if (expireAt !== null && expireAt > Date.now()) {
        return `<span style="color: #28a745; font-weight: 600;">${salonName}</span>`;
      }

      return salonName;
    },
    readDataActivity(e) {
      const url = this.$makeQueryString(
        `drivers/${this.driver.id}/request-ticket-logs`,
        this.filtersLog,
      );
      this.$persistClient("get", url)
        .then((res) => e.success(res.data))
        .catch(() => e.success([]));
    },
    readDataTickets(e) {
      this.$persistClient("get", `/drivers/${this.driver.user.id}/tickets`)
        .then((res) => {
          const rows = Array.isArray(res.data) ? res.data : [];

          const sortedRows = [...rows].sort((a, b) => {
            const aExpireAt = this.ticketExpireAtTimestamp(a.expire_at);
            const bExpireAt = this.ticketExpireAtTimestamp(b.expire_at);

            if (aExpireAt === null) {
              return bExpireAt === null ? 0 : 1;
            }

            if (bExpireAt === null) {
              return -1;
            }

            return bExpireAt - aExpireAt;
          });

          this.tickets = sortedRows;

          e.success(sortedRows);
        })
        .catch(() => {
          this.tickets = [];
          e.success([]);
        });
    },
    makeQueryStringForSpatie(mainUrl, data, firstChar = "?") {
      if (data && typeof data === "object") {
        let url = firstChar;
        for (const [key, value] of Object.entries(data)) {
          if (value !== undefined && value !== null && value !== "") {
            url += `filter[${key}]=${encodeURIComponent(value)}&`;
          }
        }
        url = url.slice(0, -1);
        return mainUrl + url;
      }
      return mainUrl;
    },
    readDataWallet(e) {
      this.pageSize = e.data.pageSize;
      this.currentPage = e.data.page;
      const baseUrl = `/drivers/wallet-report?page=${this.currentPage}&page_size=${this.pageSize}&user_id=${this.driver.user.id}`;
      const url = this.makeQueryStringForSpatie(
        baseUrl,
        this.filterWallet,
        "&",
      );
      this.$persistClient("get", url)
        .then((res) => {
          this.total_amount = res.data.data.total_amount || 0;
          e.success(res.data.data.data);
        })
        .catch(() => e.success([]));
    },
    readDataLog(e) {
      const url = this.$makeQueryString(
        `drivers/${this.driver.id}/request-tickets`,
        this.filtersLog,
      );
      this.$persistClient("get", url)
        .then((res) => {
          this.logs = res.data;
          e.success(res.data);
        })
        .catch(() => e.success([]));
    },
    loadDataLog() {
      this.$refs.logsGrid.loadDataSource();
    },
    loadDataWallet() {
      this.$refs.walletGrid.loadDataSource();
    },
    removeAccess() {
      this.$alert(
        "question",
        "آیا از رفع محدودیت رزرو این کاربر اطمینان دارید؟",
        "",
        {
          confirmButtonText: "بله",
        },
      ).then((result) => {
        if (result.value) {
          this.$persistClient("delete", `drivers/${this.driver.id}/logs`).then(
            (res) => {
              this.$izitoast(
                "success",
                "عملیات موفق",
                res.data.message
              );

              this.logAutomaticActivity(
                "reservation-limit-removed",
                "محدودیت رزرو راننده توسط اپراتور برداشته شد."
              );
            },
          );
        }
      });
    },
    onDeleteNotif(salonSelect) {
      const remainingSalonIds = this.salons
        .filter((s) => s.id !== salonSelect.id)
        .map((s) => s.id);
      this.$persistClient("post", `notification-settings`, {
        salon_ids: remainingSalonIds,
        user_id: this.driver.user.id,
      }).then((res) => {
        this.$izitoast("success", "عملیات موفق", res.data.message);
        this.logAutomaticActivity(
          "notification-setting-changed",
          `حذف سالن ${salonSelect.name} از دریافت پیامک راننده`
        );
        this.salons = this.salons.filter((s) => s.id !== salonSelect.id);
      });
    },
    openDriverActivityModal() {
      const phone =
        this.currentVoipPhone ||
        (this.mobile || "").trim() ||
        null;

      if (!(this.driver && this.driver.id) && !this.currentVoipLogId && !phone) {
        this.$izitoast(
          "warning",
          "اخطار",
          "ابتدا یک راننده یا شماره تماس را انتخاب کنید."
        );

        return;
      }

      // برای راننده ثبت‌شده یا شماره ناشناس امکان ثبت فعالیت وجود دارد.
      this.activityForm = {
        activity_slug: "",
        description: "",
      };
      this.showNewActivityForm = false;
      this.newActivityLabel = "";

      this.$toggleModal(
        "#driver-activity-modal"
      );
    },
    closeDriverActivityModal() {
      this.$toggleModal(
        "#driver-activity-modal"
      );
    },
    initMapData() {
      this.$persistClient(
        "get",
        `drivers/${this.driver.user.id}/position`,
      ).then((res) => {
        if (res.data.data) {
          const data = {
            lat: res.data.data.latitude,
            lng: res.data.data.longitude,
            action: res.data.data.action,
            name: `${this.driver.user.name} ${this.driver.user.family}`,
            created_at: this.$getJalaliDateTimeToNewFormat(
              res.data.data.created_at,
            ),
          };
          this.$nextTick(() => {
            this.renderMap(data);
          });
        }
      });
    },
    renderMap(data) {
      if (!this.map) {
        this.map = L.map("map").setView([data.lat, data.lng], 9);
        L.tileLayer(`http://www.google.com/maps/vt?lyrs=m&x={x}&y={y}&z={z}`, {
          maxNativeZoom: 19,
          maxZoom: 21,
        }).addTo(this.map);
      }
      L.marker([data.lat, data.lng])
        .addTo(this.map)
        .bindPopup(
          `<b>راننده:</b> ${data.name} <br> <b>وضعیت:</b> ${data.action} <br> <b>تاریخ:</b> ${data.created_at}`,
        )
        .openPopup();
    },
    invalidateMap() {
      setTimeout(() => {
        if (this.map) this.map.invalidateSize();
      }, 300);
    },
    statusText(e) {
      if (e) {
        return `<span class='badge' style="color:white;background-color:${e.active ? "#1ab394" : "#b33e1a"}">${e.active ? "فعال" : 'غیرفعال'}</span>`;
      }
      return "--";
    },
    addRecentPhone(phone, voipLogId = null) {
      if (!phone) return;

      this.recentPhones = this.recentPhones.filter(
        (item) => item.phone !== phone
      );

      this.recentPhones.unshift({
        id: `${phone}-${Date.now()}`,
        phone,
        voip_log_id: voipLogId,
      });

      if (this.recentPhones.length > this.maxRecent) {
        this.recentPhones.pop();
      }
    },
    removePhone(index) {
      this.recentPhones.splice(index, 1);
    },
    clearRecentPhones() {
      this.recentPhones = [];
      this.notFoundMobiles = [];
    },
    selectPhone(phone) {
      this.mobile = phone;

      const item = this.recentPhones.find(
        (x) => x.phone === phone
      );

      this.currentVoipLogId = item?.voip_log_id || null;
      this.currentVoipPhone = phone;

      this.searchMobile();
    },
  },
};
</script>

<style scoped>
/* استایل تب‌ها و کارت اطلاعات */
.custom-tabs-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  overflow: hidden;
}

.custom-nav-tabs {
  border-bottom: 2px solid #f3f3f4;
  background-color: #fcfcfc;
  padding: 0 15px;
}

.custom-nav-tabs .nav-link {
  color: #6c757d;
  font-weight: 600;
  border: none;
  border-bottom: 3px solid transparent;
  padding: 15px 20px;
  transition: all 0.3s;
}

.custom-nav-tabs .nav-link:hover {
  color: #1ab394;
  border-color: transparent;
}

.custom-nav-tabs .nav-link.active {
  color: #1ab394;
  background: transparent;
  border-bottom: 3px solid #1ab394;
}

.custom-tab-content {
  padding: 25px;
}

.section-title {
  color: #495057;
  font-weight: bold;
  margin-bottom: 0.5rem;
}

/* استایل نقشه */
.map-container {
  height: 450px;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #e7eaec;
}

#map {
  height: 100%;
  width: 100%;
}

/* ستون سمت راست: لیست شماره‌ها */
.recent-phones-box {
  background: #fff;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 20px;
}

.recent-phones-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.phone-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  padding: 10px 12px;
  border-radius: 8px;
  transition: all 0.2s;
  cursor: pointer;
}

.phone-card:hover {
  background: #eef7f4;
  border-color: #1ab394;
}

.phone-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.phone-text {
  font-weight: 600;
  color: #343a40;
}

.empty-list {
  text-align: center;
  color: #999;
  font-size: 13px;
  margin-top: 15px;
}

/* انیمیشن لیست */
.list-enter-active,
.list-leave-active {
  transition: all 0.3s ease;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.is-selected-phone {
  border: 2px greenyellow solid;
}

.not-found {
  background-color: rgba(228, 0, 0, 0.87);
}
</style>